var _style, _g, _g2, _g3, _g4, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g5, _g6, _g7, _g8, _defs2, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g9, _g10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-281 373 48 48",
    style: {
      enableBackground: "new -281 373 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{fill:#CEE4EA;}\n\t.st3{fill:#E9F2F4;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{fill:#949494;}\n\t.st6{fill:#F1F1F1;}\n\t.st7{fill:#808080;}\n\t.st8{fill:#DC1D00;}\n\t.st9{fill:#4D4D4D;}\n\t.st10{fill:#FFFEFE;}\n\t.st11{clip-path:url(#SVGID_2_);fill:#4CAF50;}\n\t.st12{fill:#4CAF50;}\n\t.st13{fill:#FAFAFA;}\n\t.st14{fill:#E2E5E7;}\n\t.st15{fill:#B0B7BD;}\n\t.st16{fill:#CAD1D8;}\n\t.st17{fill:#50BEE8;}\n\t.st18{fill:#F15642;}\n\t.st19{fill:#97D85D;}\n\t.st20{fill:#71B22D;}\n\t.st21{fill:#FC4F4F;}\n\t.st22{fill:#4A60E5;}\n\t.st23{fill:#FFD561;}\n\t.st24{fill:#2A4BD8;}\n\t.st25{fill:#E53535;}\n\t.st26{fill:#FFBE69;}\n\t.st27{fill:#FF9852;}\n\t.st28{fill:#FF8A33;}\n\t.st29{fill:#F4B04D;}\n\t.st30{fill:#F96E10;}\n\t.st31{clip-path:url(#SVGID_4_);fill:#1565C0;}\n\t.st32{fill:#1565C0;}\n\t.st33{fill:#F0C419;}\n\t.st34{fill:#F29C1F;}\n\t.st35{fill:#E57E25;}\n\t.st36{fill:#547580;}\n\t.st37{fill:#7F8C8D;}\n\t.st38{fill:#95A5A5;}\n\t.st39{fill:#F9DF5C;}\n\t.st40{fill:#F3CC30;}\n\t.st41{fill:#EDBD31;}\n\t.st42{fill:#F6D738;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "guide",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_8",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "guides"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -288,
    y: 382,
    className: "st2",
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("rect", {
    x: -286,
    y: 384,
    className: "st3",
    width: 44,
    height: 44
  }), /*#__PURE__*/React.createElement("rect", {
    x: -284,
    y: 386,
    className: "st4",
    width: 40,
    height: 40
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "pdf",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_16_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_19_",
    className: "st5",
    points: "-252.4,386.1 -252.4,386.1 -244.5,394.4 -244.5,425.9 -274.2,425.9 -274.2,426  -244.4,426 -244.4,394.5 -252.4,386.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_20_",
    className: "st6",
    points: "-252.5,386 -274.3,386 -274.3,425.9 -244.5,425.9 -244.5,394.4 -252.5,386  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_39_",
    className: "st7",
    points: "-274.5,388.1 -283.6,388.1 -283.6,397.9 -274.5,397.9 -254.9,397.9 -254.9,388.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_30_",
    x: -283.4,
    y: 388,
    className: "st8",
    width: 28.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_35_",
    className: "st9",
    d: "M-274.2,392.9c0,0-0.1,0-0.1,0v-2.1h0.3c0.3,0,0.5,0.1,0.7,0.3c0.2,0.2,0.3,0.5,0.3,0.8 c0,0.4,0,0.7-0.3,0.9C-273.6,392.9-273.9,392.9-274.2,392.9 M-273.9,389.6C-273.9,389.6-274,389.6-273.9,389.6 c-0.2,0-0.3,0-0.3,0h-1.5v6.9h1.5v-2.3l0.3,0c0.3,0,0.6-0.1,0.9-0.2c0.3-0.1,0.5-0.2,0.7-0.4c0.2-0.2,0.4-0.4,0.5-0.6 c0.1-0.4,0.2-0.9,0.1-1.3c0-0.4-0.1-0.7-0.2-0.9c-0.1-0.2-0.2-0.4-0.4-0.6c-0.2-0.2-0.4-0.3-0.6-0.3c-0.2-0.1-0.4-0.1-0.6-0.2 C-273.6,389.6-273.8,389.6-273.9,389.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_38_",
    className: "st9",
    d: "M-269.2,395.2c0,0-0.1,0-0.1,0v-4.4c0,0,0,0,0,0c0.3,0,0.7,0,0.9,0.2 c0.2,0.2,0.3,0.3,0.5,0.6c0.1,0.2,0.2,0.5,0.2,0.8c0,0.3,0,0.6,0,0.8c0,0.2,0,0.5,0,0.7c0,0.3-0.1,0.5-0.2,0.7 c-0.1,0.2-0.3,0.4-0.5,0.5C-268.8,395.2-269,395.2-269.2,395.2 M-269,389.6c-0.2,0-0.3,0-0.4,0c-0.2,0-0.3,0-0.3,0h-1.1v6.9h1.3 c0.6,0,1.1-0.1,1.5-0.3c0.4-0.2,0.7-0.4,1-0.7c0.2-0.3,0.4-0.7,0.5-1.1s0.2-0.9,0.2-1.4c0-0.6,0-1.1-0.1-1.6 c-0.1-0.4-0.3-0.8-0.6-1c-0.2-0.3-0.5-0.4-0.8-0.6c-0.3-0.1-0.5-0.2-0.8-0.3C-268.7,389.6-268.8,389.6-269,389.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_64_",
    className: "st9",
    points: "-262,389.6 -265.4,389.6 -265.4,396.5 -264,396.5 -264,393.8 -262.1,393.8  -262.1,392.5 -264,392.5 -264,390.9 -262,390.9 -262,389.6  "
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28_",
    className: "st8",
    d: "M-249.9,413c0-0.1-0.1-1.7-3-1.7c-2.8,0.1-3.5,0.2-3.5,0.2s-2.1-2.1-2.9-3.8 c0,0,0.9-2.7,0.9-4.4c0-1.7-0.5-2.7-1.8-2.7c-1.3,0-1.5,1.2-1.3,2.9c0.2,1.5,1,3.3,1,3.3s-0.6,1.9-1.4,3.8 c-0.8,1.9-1.4,2.9-1.4,2.9s-2.7,0.9-3.9,2c-1.2,1.1-1.7,1.9-1,2.8c0.5,0.7,2.4,0.9,4.1-1.3c1.7-2.2,2.4-3.6,2.4-3.6 s2.5-0.7,3.3-0.9c0.8-0.2,1.8-0.3,1.8-0.3s2.3,2.3,4.6,2.3C-249.7,414.4-249.8,413.1-249.9,413z M-267.6,417.9 c-1.4-0.8,2.9-3.4,3.7-3.5C-263.8,414.4-266.1,418.8-267.6,417.9z M-260.9,402.9c0-1.4,0.4-1.7,0.8-1.7s0.7,0.2,0.7,1.3 c0,1.2-0.7,3.5-0.7,3.5C-260.4,405.7-260.9,404.3-260.9,402.9z M-259.1,412.2c-1.4,0.3-2.1,0.7-2.1,0.7s0,0,0.6-1.3 c0.6-1.3,1.2-3,1.2-3c0.8,1.5,2.4,3.2,2.4,3.2S-257.7,411.9-259.1,412.2z M-255.7,412.1c0,0,4.6-0.8,4.6,0.7 C-251.2,414.4-254,413.7-255.7,412.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_44_",
    className: "st5",
    points: "-252.6,386.1 -252.6,394.5 -244.6,394.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_21_",
    className: "st6",
    points: "-252.5,386 -252.5,394.4 -244.5,394.4  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_23_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_43_",
    className: "st10",
    d: "M-274.3,392.8c0,0-0.1,0-0.1,0v-2.1h0.3c0.3,0,0.5,0.1,0.7,0.3c0.2,0.2,0.3,0.5,0.3,0.8 c0,0.4,0,0.7-0.3,0.9C-273.7,392.7-274,392.8-274.3,392.8 M-274,389.5C-274.1,389.5-274.1,389.5-274,389.5c-0.2,0-0.3,0-0.3,0 h-1.5v6.9h1.5v-2.3l0.3,0c0.3,0,0.6-0.1,0.9-0.2c0.3-0.1,0.5-0.2,0.7-0.4c0.2-0.2,0.4-0.4,0.5-0.6c0.1-0.4,0.2-0.9,0.1-1.3 c0-0.4-0.1-0.7-0.2-0.9c-0.1-0.2-0.2-0.4-0.4-0.6c-0.2-0.2-0.4-0.3-0.6-0.3c-0.2-0.1-0.4-0.1-0.6-0.1 C-273.8,389.5-273.9,389.5-274,389.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_32_",
    className: "st10",
    d: "M-269.3,395.1c0,0-0.1,0-0.1,0v-4.4c0,0,0,0,0,0c0.3,0,0.7,0,0.9,0.2 c0.2,0.2,0.3,0.3,0.5,0.6c0.1,0.2,0.2,0.5,0.2,0.8c0,0.3,0,0.6,0,0.8c0,0.2,0,0.5,0,0.7c0,0.3-0.1,0.5-0.2,0.7 c-0.1,0.2-0.3,0.4-0.5,0.5C-268.9,395.1-269.1,395.1-269.3,395.1 M-269.1,389.5c-0.2,0-0.3,0-0.4,0c-0.2,0-0.3,0-0.3,0h-1.1v6.9 h1.3c0.6,0,1.1-0.1,1.5-0.3c0.4-0.2,0.7-0.4,1-0.7c0.2-0.3,0.4-0.7,0.5-1.1s0.2-0.9,0.2-1.4c0-0.6,0-1.1-0.1-1.6 c-0.1-0.4-0.3-0.8-0.6-1s-0.5-0.4-0.8-0.6s-0.5-0.2-0.8-0.3C-268.8,389.5-269,389.5-269.1,389.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_24_",
    className: "st10",
    points: "-262.1,389.5 -265.5,389.5 -265.5,396.4 -264.1,396.4 -264.1,393.7 -262.2,393.7  -262.2,392.4 -264.1,392.4 -264.1,390.8 -262.1,390.8 -262.1,389.5  "
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "download-fill",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-250.5,402.4c-1.2-6.3-6.8-11.1-13.5-11.1c-5.3,0-9.9,3-12.2,7.4c-5.5,0.6-9.8,5.3-9.8,10.9 c0,6.1,4.9,11,11,11h23.8c5.1,0,9.2-4.1,9.2-9.2C-242,406.7-245.8,402.7-250.5,402.4z M-254.8,407.8l-9.2,9.2l-9.2-9.2h5.5v-7.3 h7.3v7.3H-254.8z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "copy-fill",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-267.9,419.1c-4.1,0-7.4-3.3-7.4-7.4v-17.9h-3.1c-2.7,0-4.8,2.2-4.8,4.8v23.6c0,2.7,2.2,4.8,4.8,4.8h21.9 c2.7,0,4.8-2.2,4.8-4.8v-3.1L-267.9,419.1L-267.9,419.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-244.8,389.8c0-2.7-2.2-4.8-4.8-4.8h-18.4c-2.7,0-4.8,2.2-4.8,4.8v21.9c0,2.7,2.2,4.8,4.8,4.8h18.4 c2.7,0,4.8-2.2,4.8-4.8L-244.8,389.8L-244.8,389.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "excel",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -284,
    y: 386.7,
    width: 40,
    height: 38.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M-261,387c-0.2-0.2-0.5-0.2-0.7-0.2l-21.7,5c-0.4,0.1-0.6,0.4-0.6,0.8V421c0,0.4,0.3,0.8,0.7,0.8l21.7,3.3 c0.5,0.1,0.9-0.2,1-0.7c0,0,0-0.1,0-0.1v-36.7C-260.7,387.4-260.8,387.2-261,387L-261,387z"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M-244.8,421.8h-16.7c-0.5,0-0.8-0.4-0.8-0.8s0.4-0.8,0.8-0.8h15.8v-28.3h-15.8c-0.5,0-0.8-0.4-0.8-0.8 s0.4-0.8,0.8-0.8h16.7c0.5,0,0.8,0.4,0.8,0.8v30C-244,421.5-244.4,421.8-244.8,421.8L-244.8,421.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-268.2,413.5c-0.3,0-0.6-0.1-0.7-0.4l-8.3-13.3c-0.3-0.4-0.2-0.9,0.2-1.2c0.4-0.3,0.9-0.2,1.2,0.2 c0,0,0,0,0,0l8.3,13.3c0.2,0.4,0.1,0.9-0.3,1.1C-267.9,413.5-268,413.5-268.2,413.5L-268.2,413.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-276.5,413.5c-0.5,0-0.8-0.4-0.8-0.8c0-0.2,0-0.3,0.1-0.4l8.3-13.3c0.2-0.4,0.7-0.5,1.1-0.3 c0.4,0.2,0.5,0.7,0.3,1.1c0,0,0,0,0,0l-8.3,13.3C-275.9,413.4-276.2,413.5-276.5,413.5L-276.5,413.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M-254.8,421.8c-0.5,0-0.8-0.4-0.8-0.8v-30c0-0.5,0.4-0.8,0.8-0.8c0.5,0,0.8,0.4,0.8,0.8v30 C-254,421.5-254.4,421.8-254.8,421.8L-254.8,421.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M-244.8,416.8h-16.7c-0.5,0-0.8-0.4-0.8-0.8s0.4-0.8,0.8-0.8h16.7c0.5,0,0.8,0.4,0.8,0.8 C-244,416.5-244.4,416.8-244.8,416.8L-244.8,416.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M-244.8,411.8h-16.7c-0.5,0-0.8-0.4-0.8-0.8s0.4-0.8,0.8-0.8h16.7c0.5,0,0.8,0.4,0.8,0.8 C-244,411.5-244.4,411.8-244.8,411.8L-244.8,411.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M-244.8,406.8h-16.7c-0.5,0-0.8-0.4-0.8-0.8s0.4-0.8,0.8-0.8h16.7c0.5,0,0.8,0.4,0.8,0.8 C-244,406.5-244.4,406.8-244.8,406.8L-244.8,406.8z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M-244.8,401.8h-16.7c-0.5,0-0.8-0.4-0.8-0.8s0.4-0.8,0.8-0.8h16.7c0.5,0,0.8,0.4,0.8,0.8 C-244,401.5-244.4,401.8-244.8,401.8L-244.8,401.8z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M-244.8,396.8h-16.7c-0.5,0-0.8-0.4-0.8-0.8s0.4-0.8,0.8-0.8h16.7c0.5,0,0.8,0.4,0.8,0.8 S-244.4,396.8-244.8,396.8L-244.8,396.8z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "jpg",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M-274,386c-1.4,0-2.5,1.1-2.5,2.5v35c0,1.4,1.1,2.5,2.5,2.5h25c1.4,0,2.5-1.1,2.5-2.5V396l-10-10H-274z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M-254,396h7.5l-10-10v7.5C-256.5,394.9-255.4,396-254,396z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "-246.5,403.5 -254,396 -246.5,396  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M-251.5,418.5c0,0.7-0.6,1.3-1.3,1.3h-27.5c-0.7,0-1.3-0.6-1.3-1.3V406c0-0.7,0.6-1.3,1.3-1.3h27.5 c0.7,0,1.3,0.6,1.3,1.3V418.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-272.9,409.7c0-0.8,1.3-0.8,1.3,0v3.9c0,1.6-0.8,2.5-2.5,2.5c-0.9,0-1.6-0.2-2.2-1c-0.5-0.6,0.5-1.5,1-0.9 c0.4,0.5,0.9,0.6,1.3,0.6c0.6,0,1-0.3,1.1-1.3L-272.9,409.7L-272.9,409.7L-272.9,409.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-269.8,409.7c0-0.3,0.3-0.7,0.7-0.7h2.3c1.3,0,2.5,0.9,2.5,2.5c0,1.6-1.2,2.5-2.5,2.5h-1.7v1.3 c0,0.4-0.3,0.7-0.6,0.7c-0.3,0-0.7-0.2-0.7-0.7V409.7L-269.8,409.7z M-268.5,410.3v2.5h1.7c0.7,0,1.2-0.6,1.2-1.2 c0-0.7-0.5-1.3-1.2-1.3C-266.8,410.3-268.5,410.3-268.5,410.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-257.2,415.2c-0.7,0.6-1.6,0.8-2.5,0.8c-2.1,0-3.6-1.2-3.6-3.6c0-2,1.6-3.6,3.7-3.6c0.8,0,1.7,0.3,2.3,0.9 c0.6,0.6-0.3,1.5-0.9,1c-0.4-0.4-0.9-0.6-1.4-0.6c-1.2,0-2.4,1-2.4,2.4c0,1.5,1,2.4,2.3,2.4c0.6,0,1.1-0.2,1.5-0.4v-1.2h-1.5 c-0.9,0-0.8-1.2,0-1.2h2c0.4,0,0.7,0.3,0.7,0.6v2.1C-257,414.9-257.1,415-257.2,415.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M-252.8,419.8h-23.8v1.3h23.8c0.7,0,1.3-0.6,1.3-1.3v-1.3C-251.5,419.2-252.1,419.8-252.8,419.8z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "ppt",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M-274,386c-1.4,0-2.5,1.1-2.5,2.5v35c0,1.4,1.1,2.5,2.5,2.5h25c1.4,0,2.5-1.1,2.5-2.5V396l-10-10H-274z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M-251.5,418.5c0,0.7-0.6,1.3-1.3,1.3h-27.5c-0.7,0-1.3-0.6-1.3-1.3V406c0-0.7,0.6-1.3,1.3-1.3h27.5 c0.7,0,1.3,0.6,1.3,1.3V418.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-275.8,409.7c0-0.3,0.3-0.7,0.7-0.7h2.3c1.3,0,2.5,0.9,2.5,2.5c0,1.6-1.2,2.5-2.5,2.5h-1.7v1.3 c0,0.4-0.3,0.7-0.6,0.7c-0.3,0-0.7-0.2-0.7-0.7V409.7L-275.8,409.7z M-274.4,410.3v2.5h1.7c0.7,0,1.2-0.6,1.2-1.2 c0-0.7-0.5-1.3-1.2-1.3C-272.8,410.3-274.4,410.3-274.4,410.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-269,409.7c0-0.3,0.3-0.7,0.7-0.7h2.3c1.3,0,2.5,0.9,2.5,2.5c0,1.6-1.2,2.5-2.5,2.5h-1.7v1.3 c0,0.4-0.3,0.7-0.6,0.7c-0.3,0-0.7-0.2-0.7-0.7C-269,415.3-269,409.7-269,409.7z M-267.7,410.3v2.5h1.7c0.7,0,1.2-0.6,1.2-1.2 c0-0.7-0.5-1.3-1.2-1.3C-266,410.3-267.7,410.3-267.7,410.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-260.4,410.3h-1.7c-0.9,0-0.9-1.3,0-1.3h4.7c0.9,0,0.9,1.3,0,1.3h-1.7v5c0,0.9-1.3,0.9-1.3,0V410.3z"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "rar",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M-246.2,386h-35.7c-0.7,0-1.2,0.5-1.2,1.2v37.6c0,0.6,0.5,1.2,1.2,1.2h35.7c0.7,0,1.2-0.5,1.2-1.2v-37.6 C-245,386.5-245.5,386-246.2,386L-246.2,386z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-246.2,386.8h-17.5V426h17.5c0.6,0,1.2-0.5,1.2-1.2v-36.9C-245,387.3-245.5,386.8-246.2,386.8L-246.2,386.8 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M-246.2,398.6h-35.6c-0.7,0-1.2,0.5-1.2,1.2v13.6h38v-13.6C-245,399.2-245.5,398.6-246.2,398.6L-246.2,398.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M-246.2,386h-35.6c-0.7,0-1.2,0.5-1.2,1.1v12.4h38v-12.4C-245,386.5-245.5,386-246.2,386L-246.2,386z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M-274.2,415.8h-4c-0.7,0-1.2,0.5-1.2,1.2v5.7c0,0.7,0.5,1.2,1.2,1.2h4c0.7,0,1.2-0.5,1.2-1.2v-5.7 C-273.1,416.3-273.6,415.8-274.2,415.8L-274.2,415.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M-274.2,402.4h-4c-0.7,0-1.2,0.5-1.2,1.2v5.7c0,0.7,0.5,1.2,1.2,1.2h4c0.7,0,1.2-0.5,1.2-1.2v-5.7 C-273.1,402.9-273.6,402.4-274.2,402.4L-274.2,402.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M-274.2,388.6h-4c-0.7,0-1.2,0.5-1.2,1.2v5.7c0,0.7,0.5,1.2,1.2,1.2h4c0.7,0,1.2-0.5,1.2-1.2v-5.7 C-273.1,389.2-273.6,388.6-274.2,388.6L-274.2,388.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M-246.2,386h-17.5v13.4h18.6v-12.4C-245,386.5-245.5,386-246.2,386L-246.2,386z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -263.6,
    y: 398.6,
    className: "st25",
    width: 18.6,
    height: 14.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M-259.2,426c0.7,0,1.2-0.5,1.2-1.2v-37.6c0-0.6-0.5-1.2-1.2-1.2h-10.1v40H-259.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -269.2,
    y: 401,
    className: "st27",
    width: 11.2,
    height: 9.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M-263.6,399c-0.7,0-1.2,0.5-1.2,1.2v3.6c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2v-3.6 C-262.4,399.5-263,399-263.6,399L-263.6,399z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -263.6,
    y: 386,
    className: "st29",
    width: 5.6,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    x: -263.6,
    y: 401,
    className: "st28",
    width: 5.6,
    height: 9.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M-263.6,399v6c0.7,0,1.2-0.5,1.2-1.2v-3.6C-262.4,399.5-263,399-263.6,399L-263.6,399z"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "vision",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-244.2,405.3c-0.4-0.5-8.9-12.2-19.7-12.2c-10.8,0-19.5,11.7-19.9,12.2c-0.3,0.4-0.3,1,0,1.4 c0.4,0.5,9,12.2,19.9,12.2c10.8,0,19.3-11.7,19.7-12.2C-243.9,406.3-243.9,405.7-244.2,405.3z M-263.9,414.2 c-4.5,0-8.4-3.7-8.4-8.2s3.8-8.2,8.4-8.2s8.2,3.7,8.2,8.2S-259.4,414.2-263.9,414.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "word",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: -284,
    y: 386.7,
    width: 40,
    height: 38.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M-261,387c-0.2-0.2-0.5-0.2-0.7-0.2l-21.7,5c-0.4,0.1-0.6,0.4-0.6,0.8V421c0,0.4,0.3,0.8,0.7,0.8l21.7,3.3 c0.5,0.1,0.9-0.2,1-0.7c0,0,0-0.1,0-0.1v-36.7C-260.7,387.4-260.8,387.2-261,387L-261,387z"
  })))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M-244.8,421.8h-16.7c-0.5,0-0.8-0.4-0.8-0.8s0.4-0.8,0.8-0.8h15.8v-28.3h-15.8c-0.5,0-0.8-0.4-0.8-0.8 s0.4-0.8,0.8-0.8h16.7c0.5,0,0.8,0.4,0.8,0.8v30C-244,421.5-244.4,421.8-244.8,421.8L-244.8,421.8z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-269.8,413.5c-0.4,0-0.7-0.2-0.8-0.6l-2.5-8.9l-2.5,8.9c-0.2,0.4-0.7,0.7-1.1,0.5c-0.2-0.1-0.4-0.3-0.5-0.5 l-3.3-11.7c-0.1-0.4,0.1-0.9,0.5-1c0.4-0.1,0.9,0.1,1,0.5c0,0,0,0,0,0l2.5,8.9l2.5-8.9c0.2-0.4,0.7-0.7,1.1-0.5 c0.2,0.1,0.4,0.3,0.5,0.5l2.5,8.9l2.5-8.9c0.1-0.4,0.6-0.7,1-0.6c0,0,0,0,0,0c0.4,0.1,0.7,0.6,0.6,1l-3.3,11.7 C-269.1,413.3-269.5,413.5-269.8,413.5L-269.8,413.5z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M-248.2,396.8h-13.3c-0.5,0-0.8-0.4-0.8-0.8s0.4-0.8,0.8-0.8h13.3c0.5,0,0.8,0.4,0.8,0.8 C-247.3,396.5-247.7,396.8-248.2,396.8L-248.2,396.8z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M-248.2,401.8h-13.3c-0.5,0-0.8-0.4-0.8-0.8s0.4-0.8,0.8-0.8h13.3c0.5,0,0.8,0.4,0.8,0.8 C-247.3,401.5-247.7,401.8-248.2,401.8L-248.2,401.8z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M-248.2,406.8h-13.3c-0.5,0-0.8-0.4-0.8-0.8s0.4-0.8,0.8-0.8h13.3c0.5,0,0.8,0.4,0.8,0.8 C-247.3,406.5-247.7,406.8-248.2,406.8L-248.2,406.8z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M-248.2,411.8h-13.3c-0.5,0-0.8-0.4-0.8-0.8s0.4-0.8,0.8-0.8h13.3c0.5,0,0.8,0.4,0.8,0.8 C-247.3,411.5-247.7,411.8-248.2,411.8L-248.2,411.8z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M-248.2,416.8h-13.3c-0.5,0-0.8-0.4-0.8-0.8s0.4-0.8,0.8-0.8h13.3c0.5,0,0.8,0.4,0.8,0.8 C-247.3,416.5-247.7,416.8-248.2,416.8L-248.2,416.8z"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "zip",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M-244,399.1v20c0,2.3-1.9,4.1-4.1,4.1h-31.7c-2.3,0-4.1-1.9-4.1-4.1v-30.3c0-1.5,1.2-2.8,2.8-2.8h15.2 c1.5,0,2.8,1.2,2.8,2.8v1.4h12.4c1.5,0,2.8,1.2,2.8,2.8v2.1C-245.9,395-244,396.8-244,399.1L-244,399.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M-248.1,392.9v2.1H-284v-6.2c0-1.5,1.2-2.8,2.8-2.8h15.2c1.5,0,2.8,1.2,2.8,2.8v1.4h12.4 C-249.4,390.1-248.1,391.4-248.1,392.9L-248.1,392.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M-271.6,395h-2.8c-0.4,0-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7h2.8c0.4,0,0.7,0.3,0.7,0.7S-271.2,395-271.6,395 L-271.6,395z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M-264,414.3c-0.4,0-0.7-0.3-0.7-0.7V395c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7v18.6 C-263.3,414-263.6,414.3-264,414.3L-264,414.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M-266.1,398.4h-0.7c-0.4,0-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7h0.7c0.4,0,0.7,0.3,0.7,0.7 S-265.7,398.4-266.1,398.4L-266.1,398.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M-266.1,401.2h-0.7c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7h0.7c0.4,0,0.7,0.3,0.7,0.7 C-265.4,400.9-265.7,401.2-266.1,401.2L-266.1,401.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M-266.1,403.9h-0.7c-0.4,0-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7h0.7c0.4,0,0.7,0.3,0.7,0.7 S-265.7,403.9-266.1,403.9L-266.1,403.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M-266.1,406.7h-0.7c-0.4,0-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7h0.7c0.4,0,0.7,0.3,0.7,0.7 S-265.7,406.7-266.1,406.7L-266.1,406.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M-266.1,409.4h-0.7c-0.4,0-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7h0.7c0.4,0,0.7,0.3,0.7,0.7 S-265.7,409.4-266.1,409.4L-266.1,409.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M-266.1,412.2h-0.7c-0.4,0-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7h0.7c0.4,0,0.7,0.3,0.7,0.7 S-265.7,412.2-266.1,412.2L-266.1,412.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M-261.2,399.8h-0.7c-0.4,0-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7h0.7c0.4,0,0.7,0.3,0.7,0.7 S-260.9,399.8-261.2,399.8L-261.2,399.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M-261.2,402.6h-0.7c-0.4,0-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7h0.7c0.4,0,0.7,0.3,0.7,0.7 S-260.9,402.6-261.2,402.6L-261.2,402.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M-261.2,405.3h-0.7c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7h0.7c0.4,0,0.7,0.3,0.7,0.7 C-260.6,405-260.9,405.3-261.2,405.3L-261.2,405.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M-261.2,408.1h-0.7c-0.4,0-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7h0.7c0.4,0,0.7,0.3,0.7,0.7 S-260.9,408.1-261.2,408.1L-261.2,408.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M-261.2,410.8h-0.7c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7h0.7c0.4,0,0.7,0.3,0.7,0.7 C-260.6,410.5-260.9,410.8-261.2,410.8L-261.2,410.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M-261.9,417.7l2.7,6.4c0.2,0.4,0.1,0.9-0.1,1.3c-0.3,0.4-0.7,0.6-1.1,0.6h-6.9c-0.5,0-0.9-0.2-1.1-0.6 c-0.3-0.4-0.3-0.9-0.1-1.3l2.7-6.4H-261.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M-263.3,423.9h-1.4c-0.4,0-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7h1.4c0.4,0,0.7,0.3,0.7,0.7 S-262.9,423.9-263.3,423.9L-263.3,423.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M-248.1,393.6v1.4h-20c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7L-248.1,393.6L-248.1,393.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M-266.1,413.6h4.1c0.4,0,0.7,0.3,0.7,0.7v2.8c0,0.4-0.3,0.7-0.7,0.7h-4.1c-0.4,0-0.7-0.3-0.7-0.7v-2.8 C-266.8,413.9-266.5,413.6-266.1,413.6L-266.1,413.6z"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_156_",
    className: "st39",
    d: "M-256.8,384.6v-0.5c0-0.8-0.7-1.4-1.6-1.4h-16.4c-0.9,0-1.6,0.6-1.6,1.4v25.4h39.2V386 c0-0.8-0.7-1.4-1.6-1.4H-256.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_154_",
    x: -274.7,
    y: 386.6,
    className: "st4",
    width: 36.1,
    height: 23.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_149_",
    className: "st40",
    d: "M-257.4,389.5l-0.6,1.4h-16.9c-0.9,0-1.6,0.6-1.6,1.4v17.9c0,0.8,0.7,1.4,1.6,1.4h36 c0.9,0,1.6-0.6,1.6-1.4V390c0-0.8-0.7-1.4-1.6-1.4h-17.1C-256.6,388.6-257.2,388.9-257.4,389.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M-237.2,410.2v-11.7c-10.9,9.4-29.8,12-38.8,12.6c0.3,0.3,0.7,0.4,1.1,0.4h36 C-237.9,411.6-237.2,411-237.2,410.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M-260.5,392.1h-13.3c-0.7,0-1.3,0.5-1.3,1.1v2.5C-272.9,394.3-267.8,392.6-260.5,392.1z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.a1b63e614f820173627645b34ff42dcf.svg";
export { ForwardRef as ReactComponent };